import React, { useEffect, useState, useMemo } from 'react'
import { Spin, Tooltip, Typography, Input, Empty } from 'antd'
import { useSelector, useDispatch } from 'react-redux';

import ProductImg from "../../../../../assets/images/newImages/nestle.svg";
import ArrowIcon from "../../../../../assets/icons/circle-right-arrow.svg";
import WarningInfoIcon from "../../../../../assets/images/newImages/info-icon.svg";

import AgGrid from "../../../../../components/ag-grid-table/index";
import ProgressBar from '../../../../../components/uiComponent/progressBar/index.js'
import Badge from '../../../../../components/uiComponent/bages/index.js';
import Button from "../../../../../components/uiComponent/button/index";
import WarningIcon from '../../../../../assets/icons/warning-modal-icon.svg'
import Modal from "../../../../../components/uiComponent/modal"

import { DeleteModalStyleWrapper } from "../../../../../containers/logistics/orders/warehouse/shipping/style.js"


import {
  CancelInboundPlan,
  GetShipmentDetails,
  updateState as updateShipmentPlanState
} from '../../../../../slices/shipment-plan.js';

import AddSkuToPlanDrawer from '../../../../logistics/orders/warehouse/shipping/steps/step2/AddSkuToPlanDrawer.js';

import {
  GetOrderItems,
  GetWorkOrderDetails
} from '../../../../../slices/work-orders.js';

import {
  GetPackingItems
} from '../../../../../slices/post-shipment.js';

import { ConfirmPlacementWrapper } from './style'
import { useNavigate, useParams } from 'react-router-dom';
import { capitalize, groupBy, map, sumBy } from 'lodash';

const defaultColDef = {
  resizable: true,
  sortable: false,
  filter: false,
  suppressRowClickSelection: true,
  suppressMenu: true,
  suppressMovable: true,
};

const ConfirmPlacement = () => {

  const [isDeleteBox, setIsDeleteBox] = useState(false);
  const [itemsSearch, setItemsSearch] = useState('');
  const [showAddSkuDrawer, setShowAddSkuDrawer] = useState(false);

  const dispatch = useDispatch();

  const { workOrderId } = useParams();
  const navigate = useNavigate();

  const {
    inboundPlanId,
  } = useSelector((state) => state.workOrders || {});

  const {
    cancelingInboundPlan
  } = useSelector((state) => state.shipmentPlan || {});

  const {
    fetchingShipmentDetails,
    shipments = [],
    workOrder = {},
    workOrderItems: planItems = [],
    addressInfo = {},
    packingMethod: planPackingMethod,
  } = useSelector((state) => state.shipmentPlan || {});

  const {
    orderItems = [],
    fetchingOrderItems,
  } = useSelector((state) => state.workOrders || {});

  const {
    packingItems = [],
    fetchingPackingItems,
  } = useSelector((state) => state.postShipment || {});

  const { currentUser } = useSelector((state) => state.auth || {});

  const handleCancelInboundPlan = () => {
    setIsDeleteBox(true)
    const planId = inboundPlanId || workOrder?.inbound_plan_id || shipments?.[0]?.inbound_plan_id || shipments?.[0]?.amazon_inbound_plan_id;
    dispatch(CancelInboundPlan({
      inboundPlanId: planId,
      workOrderId
    }))
      .then(({ payload }) => {
        if (payload?.success) navigate(`/inventory/work-order/${workOrderId}`);
      });
  };

  const mergedPackingItems = useMemo(() => {
    return map(groupBy(packingItems, "msku"), (group) => {
      const firstItem = group[0];
      const orderItem = orderItems.find(oi => oi.msku === firstItem.msku || oi.sku === firstItem.msku);

      const asin = firstItem?.asin ||
        firstItem?.vendorasin?.asin ||
        orderItem?.asin ||
        orderItem?.vendorasin?.asin ||
        firstItem?.product_details?.find(p => p.identifier_type?.toUpperCase() === 'ASIN')?.identifier_value ||
        orderItem?.product_details?.find(p => p.identifier_type?.toUpperCase() === 'ASIN')?.identifier_value;

      return {
        ...firstItem,
        asin: asin || 'N/A',
        quantity: sumBy(group, (item) => Number(item.quantity)),
        boxed_quantity: sumBy(group, (item) => Number(item.boxed_quantity || 0)),
      };
    });
  }, [packingItems, orderItems]);

  const mergedPlanItems = useMemo(() => {
    return planItems.map(item => {
      const orderItem = orderItems.find(oi => oi.msku === item.msku || oi.sku === item.msku);
      const asin = item?.asin || orderItem?.asin || 'N/A';
      return { ...item, asin };
    });
  }, [planItems, orderItems]);

  const displayItems = useMemo(() => {
    if (packingItems?.length > 0) {
      if (planPackingMethod === 'pack_now') {
        return mergedPackingItems;
      }
      return mergedPackingItems.map(item => {
        const planItem = mergedPlanItems.find(p => p.msku === item.msku);
        return {
          ...item,
          boxed_quantity: planItem ? planItem.boxed_quantity : item.boxed_quantity,
        };
      });
    }
    return mergedPlanItems;
  }, [packingItems, mergedPackingItems, mergedPlanItems, planPackingMethod]);

  const activeShipments = (shipments || []).filter(s => !!s.amazon_shipment_confirmation_id);

  useEffect(() => {
    dispatch(GetWorkOrderDetails(workOrderId)).then(({ payload }) => {
      if (payload?.data?.status === 'Draft') {
        navigate('/work-orders', { replace: true });
        return;
      }

      dispatch(updateShipmentPlanState({ key: 'workOrder', value: {} }));
      dispatch(GetShipmentDetails({ workOrderId }));
      dispatch(GetOrderItems({
        workOrderId,
        page: { pageSize: 1000, pageNumber: 1 }
      }));
      dispatch(GetPackingItems({ workOrderId }));
    });
  }, [workOrderId]);

  const columnDefs = [
    {
      headerName: "Product Name",
      field: "item_name",
      sortable: true,
      flex: 1,
      cellRenderer: ({ data }) => (
        <div className='product-item-wrapper'>
          <img
            src={data?.image_url || ProductImg}
            alt="Product"
          />
          <Tooltip title={data?.item_name || 'N/A'}>
            <span className='product-item'>{data?.item_name || 'N/A'}</span>
          </Tooltip>
        </div>
      ),
    },
    {
      headerName: "SKU",
      field: "msku",
      sortable: true,
      flex: 1,
      cellRenderer: ({ data }) => (
        <Tooltip title={data?.msku || 'N/A'}>
          <p>{data?.msku || 'N/A'}</p>
        </Tooltip>
      ),
    },
    {
      headerName: "ASIN",
      field: "asin",
      sortable: true,
      flex: 1,
      cellRenderer: ({ data }) => (
        <Tooltip title={data?.asin || 'N/A'}>
          <p>{data?.asin || 'N/A'}</p>
        </Tooltip>
      ),
    },
    {
      headerName: "Ship Quantity",
      field: "quantity",
      sortable: true,
      flex: 1,
      cellRenderer: ({ data }) => (
        <p>{data?.quantity || '0'}</p>
      ),
    },
    {
      headerName: "Packed Quantity",
      field: "boxed_quantity",
      sortable: true,
      flex: 1,
      cellRenderer: ({ data }) => (
        <p>{data?.boxed_quantity || '0'}</p>
      ),
    },
  ];

  const { wh_name = '', address_line_1 = '', city = '', state_or_province = '', zipcode = '', country = '' } = addressInfo || {};
  const address = `${wh_name}, ${address_line_1}, ${city}, ${state_or_province} ${zipcode}, ${country}`;

  // Normalize for accent-insensitive search (e.g. "al" matches "Ál", "Al", "Àl")
  const normalizeForSearch = (str) => {
    if (str == null || str === '') return '';
    const s = String(str).toLowerCase();
    return s.normalize('NFD').replace(/\p{M}/gu, '');
  };

  const toSearchStr = (val) => {
    if (val == null) return '';
    if (Array.isArray(val)) return val.map((v) => String(v ?? '')).join(' ').toLowerCase();
    return String(val).toLowerCase();
  };

  const filteredWorkOrderItems = (() => {
    if (!itemsSearch?.trim()) return displayItems;
    const q = normalizeForSearch(itemsSearch.trim());
    return displayItems.filter((row) => {
      const title = normalizeForSearch(toSearchStr(row?.item_name));
      const sku = normalizeForSearch(toSearchStr(row?.msku));
      const asin = normalizeForSearch(toSearchStr(row?.asin));
      const upc = normalizeForSearch(toSearchStr(row?.upc));
      return title.includes(q) || sku.includes(q) || asin.includes(q) || upc.includes(q);
    });
  })();

  return (
    <ConfirmPlacementWrapper>
      <header>
        <div className='items-wrapper'>
          <p>Order Name</p>
          <p>{workOrder?.name || 'N/A'}</p>
        </div>
        {/* <div className='items-wrapper'>
          <p>Order Status</p>
          <p>{workOrder?.status || 'N/A'}</p>
        </div> */}
        <div className='items'>
          <label>Status</label>
          <Badge circleStatus status={capitalize(workOrder?.workOrderInfo?.status) || ''} />
        </div>
        <div className='items-wrapper'>
          <p>Type</p>
          <p>{workOrder?.workOrderInfo?.order_type || 'N/A'}</p>
        </div>
        <div className="items-wrapper">
          <p>Progress</p>
          {displayItems?.length > 0 ? (() => {
            const total = displayItems.reduce((sum, item) => sum + Number(item.quantity || 0), 0);
            const current = displayItems.reduce((sum, item) => sum + Number(item.boxed_quantity || 0), 0);

            let status = 'grey';
            if (current === 0) status = 'grey';
            else if (total === current) status = 'success';
            else status = 'warning';

            return (
              <p>
                <ProgressBar status={status} labelText={`${current}/${total} Packed`} current={current} total={total} />
              </p>
            );
          })() : (
            <p>---</p>
          )}
        </div>
        <div className='items-wrapper'>
          <p>Ship from Address</p>
          <p>{address_line_1 ? address : '1057 Pennsylvania Ave linden nj 07036'}</p>
        </div>
        <div className='items-wrapper'>
          <p>Label Owner</p>
          <p>{workOrder?.workOrderInfo?.label_owner || 'NONE'}</p>
        </div>
        <div className='items-wrapper'>
          <p>Box Packing  Information</p>
          <p>{workOrder?.workOrderInfo?.box_packing_information}</p>
        </div>
      </header>
      <Spin tip='Loading...' spinning={fetchingShipmentDetails || fetchingOrderItems || fetchingPackingItems || cancelingInboundPlan}>
        <div className='content-wrapper'>
          <div className='table-content'>
            <div className='table-content-header'>
              <h2>Items</h2>
              <Input
                allowClear
                placeholder='Search by Title, SKU, ASIN and UPC'
                value={itemsSearch}
                onChange={(e) => setItemsSearch(e.target.value)}
                style={{ width: 280 }}
                className='items-search-input'
              />
              {currentUser?.role_id === 2 && (
                <Button
                  text="Add SKU"
                  className="outlined"
                  onClick={() => setShowAddSkuDrawer(true)}
                  style={{ marginLeft: 8 }}
                />
              )}
            </div>
            <AgGrid
              user_referrals={filteredWorkOrderItems}
              defaultColDef={defaultColDef}
              columnDefinitions={columnDefs}
              rowHeight={64}
              headerHeight={36}
              height="310px"
              masterDetail={true}
              detailRowAutoHeight={true}
              className="sku-table"
            />
          </div>
          <div className='cards-content'>
            <div
              className="flex"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "baseline"
              }}
            >
              <h2>Shipments details</h2>
            </div>
            <div className='cards-container'>
              <div className='active-item-wrapper'>
                <div className='item'>
                  <p>Placement Option</p>
                  <p>{activeShipments?.length > 0 ? 'Placement Option 1' : '---'}</p>
                </div>
                <div className='item'>
                  <p>Shipments</p>
                  <p>{activeShipments?.length > 0 ? activeShipments.length : '---'}</p>
                </div>
                <div className='item'>
                  <p>Placement Fee</p>
                  <p>{activeShipments?.length > 0 ? `$${workOrder?.placement_fee || 0}` : '---'}</p>
                </div>
              </div>
              <div className='products-cards'>
                {activeShipments?.length > 0 ? activeShipments.map((shipment, index) => {
                  const {
                    amazon_shipment_confirmation_id,
                    totalSkus,
                    totalUnits,
                    destination_city,
                    destination_postal_code,
                    amazon_warehouse_id,
                    miles,
                  } = shipment || {};

                  return (
                    <div key={shipment.id} className='cards-items'>
                      <div className='item'>
                        <div className='cards-header'>
                          <p>Shipment {index + 1}</p>

                          {(() => {
                            const shipmentItems = Array.isArray(shipment.shipment_items_info)
                              ? shipment.shipment_items_info
                              : JSON.parse(shipment.shipment_items_info || '[]');

                            const current = shipmentItems.reduce((sum, item) => sum + (Number(item.boxed_quantity) || 0), 0);
                            const total = shipmentItems.reduce((sum, item) => sum + (Number(item.quantity) || 0), 0);

                            let status = 'grey';

                            if (current === 0) {
                              status = 'grey'
                            }
                            else if (total === current) status = 'success'
                            else if (current < total) status = 'warning'
                            else status = 'warning'

                            return (
                              <ProgressBar
                                status={status}
                                className="work-order-placement"
                                labelText="Packed"
                                current={current}
                                total={total}
                              />
                            );
                          })()}
                        </div>
                        {/* <img src={ArrowIcon} alt="Arrow Icon" onClick={() => handleImageClick(shipment?.id)} style={{ cursor: 'pointer' }} /> */}
                      </div>
                      <div className='row-items'>
                        <div className='items'>
                          <p>Shipment ID</p>
                          <p>
                            <Tooltip title={amazon_shipment_confirmation_id}>
                              {amazon_shipment_confirmation_id}
                            </Tooltip>
                          </p>
                        </div>
                        <div className='items'>
                          <p>FC ID</p>
                          <Tooltip title={amazon_warehouse_id}>
                            <p className='fc-address'>{amazon_warehouse_id}</p>
                          </Tooltip>
                        </div>
                        <div className='items'>
                          <p>City</p>
                          <Tooltip title={destination_city}>
                            <p className='fc-address'>{destination_city}</p>
                          </Tooltip>
                        </div>
                        <div className='items'>
                          <p>Postal Code</p>
                          <Tooltip title={destination_postal_code}>
                            <p className='fc-address'>{destination_postal_code}</p>
                          </Tooltip>
                        </div>
                        <div className='items'>
                          <p>Total SKUs</p>
                          <p>{totalSkus || '0'}</p>
                        </div>
                        <div className='items'>
                          <p>Total Units</p>
                          <p>{totalUnits || '0'}</p>
                        </div>
                       
                      </div>
                    </div>
                  )
                }) : (
                  <div style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No shipments found" />
                  </div>
                )}
              </div>
            </div>
            <Button
              text="Cancel Plan"
              className="danger mt-2 ms-auto mb-0"
              minWidth="90px"
              disabled={cancelingInboundPlan}
              onClick={() => setIsDeleteBox(true)}
            />
          </div>
        </div>
      </Spin>
      <Modal
        saveText="Yes"
        className="Delete-modal-wrapper-item"
        onClose={() => setIsDeleteBox(false)}
        onSave={handleCancelInboundPlan}
        buttonDisabled={cancelingInboundPlan}
        closeText="No"
        centerAlign
        size="small"
        open={isDeleteBox}
        removeIcon
      >
        <DeleteModalStyleWrapper>
          <div className='delete-modal-wrapper'>
            <img src={WarningIcon} alt='WarningIcon' title='WarningIcon' />
            <Typography fontSize={24} component="h3" marginTop={3}>Warning</Typography>
            <span className='modal-body'>
            <p>Are you sure you want to cancel this Plan?</p>
            </span>
          </div>
        </DeleteModalStyleWrapper>
      </Modal>
      <AddSkuToPlanDrawer
        open={showAddSkuDrawer}
        onClose={() => setShowAddSkuDrawer(false)}
        packingMethod={planPackingMethod}
        shipmentType="SP"
      />
    </ConfirmPlacementWrapper>
  )
}

export default ConfirmPlacement;
